import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './core-6f498fd9.js';
var CsmTab = /** @class */ (function () {
    function CsmTab(hostRef) {
        registerInstance(this, hostRef);
        this.csmTabSelect = createEvent(this, "csmTabSelect", 7);
    }
    /**
     * Watch for selected and disabled props changes
     */
    CsmTab.prototype.updateParent = function () {
        this.element.parentElement.updateTab();
    };
    CsmTab.prototype.render = function () {
        if (this.selected) {
            return (h(Host, null, h("slot", null)));
        }
    };
    Object.defineProperty(CsmTab.prototype, "element", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CsmTab, "watchers", {
        get: function () {
            return {
                "selected": ["updateParent"],
                "disabled": ["updateParent"]
            };
        },
        enumerable: true,
        configurable: true
    });
    return CsmTab;
}());
export { CsmTab as csm_tab };
